import React, { FC } from "react";
import CityCard from "./../Cities/CityCard";
import useCustomerContext from "../../../modules/customers/hooks/useCustomerContext";
import EventCity from "../../../modules/eventCities/types/EventCity";

export interface AsideEventCityCardProps {
    eventCity: EventCity;
}

const AsideEventCityCard: FC<AsideEventCityCardProps> = ({
    eventCity,
}) => {
    const { languageCode } = useCustomerContext();

    return (
        <CityCard
            key={eventCity.city}
            cityImage={eventCity.bannerContentUrl}
            cityName={eventCity.eventCustomName[languageCode] || eventCity.cityName[languageCode]}
            eventCityId={eventCity.id}
        />
    );
};

export default AsideEventCityCard;
